export default __webpack_public_path__ + "static/media/espn.233bd386.png";